import React from "react";
import {
  FaUser,
  FaHome,
  FaThumbsUp,
  FaLayerGroup,
} from "react-icons/fa";
import getImageUrl from "../../utils/imageUtils";
import {
  FEED_SOURCE_FILTERS,
  FEED_FILTERS,
  isFeedSourceFilterActive,
} from "../../pages/feed/feedConstants";
import styles from "../../styles/pages/feed/FeedPage.module.css";

const FeedLeftSidebar = ({
  currentUser,
  activeFilter,
  activeTab,
  showingMatches,
  showingBattles,
  showingFlex,
  showingAsk,
  onProfileClick,
  onFeedSourceClick,
  onFeedTab,
}) => (
  <aside className={styles.leftSidebar}>
      <div className={styles.sidebarCard}>
        <div className={styles.userProfileCard}>
          <div
            className={styles.userAvatar}
            onClick={onProfileClick}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onProfileClick?.();
              }
            }}
            aria-label="View your profile"
          >
            {currentUser?.avatar ? (
              <img
                src={getImageUrl(currentUser.avatar)}
                alt={`${currentUser.fullName || "User"} avatar`}
                className={styles.userAvatarImage}
              />
            ) : (
              <FaUser className={styles.userAvatarIcon} />
            )}
          </div>
          <h3
            className={styles.username}
            onClick={onProfileClick}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onProfileClick?.();
              }
            }}
          >
            {currentUser?.fullName || currentUser?.username}
          </h3>
        </div>
      </div>

      <div className={styles.sidebarDivider} />

      <div className={styles.sidebarCard}>
        <h3>
          <FaHome /> Home
        </h3>
        <div className={styles.sidebarFilterList}>
          {FEED_SOURCE_FILTERS.map((f) => {
            const Icon = f.icon;
            const isActive = isFeedSourceFilterActive(
              f.id,
              activeFilter,
              activeTab,
              showingMatches,
            );
            return (
              <button
                key={f.id}
                type="button"
                className={`${styles.sidebarFilterButton} ${
                  isActive ? styles.sidebarFilterButtonActive : ""
                }`}
                onClick={() => onFeedSourceClick(f.id)}
                aria-pressed={isActive}
                title={f.title}
              >
                <Icon aria-hidden="true" />
                <span>{f.label}</span>
              </button>
            );
          })}
          <button
            type="button"
            className={`${styles.sidebarFilterButton} ${
              showingMatches ? styles.sidebarFilterButtonActive : ""
            }`}
            onClick={() => onFeedTab("matches")}
            aria-pressed={showingMatches}
          >
            <FaThumbsUp aria-hidden="true" />
            <span>My matches</span>
          </button>
        </div>
      </div>

      <div className={styles.sidebarDivider} />

      <div className={styles.sidebarCard}>
        <h3>
          <FaLayerGroup /> Content
        </h3>
        <div className={styles.sidebarFilterList}>
          {FEED_FILTERS.map((f) => {
            const Icon = f.icon;
            const isActive = f.isBattles
              ? showingBattles
              : f.isFlex
                ? showingFlex
                : showingAsk;
            return (
              <button
                key={f.id}
                type="button"
                className={`${styles.sidebarFilterButton} ${
                  isActive ? styles.sidebarFilterButtonActive : ""
                }`}
                onClick={() => onFeedTab(f.id)}
                aria-pressed={isActive}
                title={f.title}
              >
                <Icon aria-hidden="true" />
                <span>{f.label}</span>
              </button>
            );
          })}
        </div>
      </div>
    </aside>
);

export default React.memo(FeedLeftSidebar);
